module.exports = __webpack_public_path__ + "static/media/happyJoyBg.416af49d.ogg";